import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'

import languageKey from '../../../../i18n/languageKey'
import useLanguage from './useLanguage'

export type LanguageType = {}
const Language = (props: LanguageType) => {
    const classes = useStyles()
    const language = useLanguage(props)
    return (
        <Grid container alignContent="center" style={{ color: 'black', height: '100%' }}>
            <Grid container item xs alignContent="center">
                <IconButton
                    size="small"
                    onClick={language.onClickEN}
                    className={clsx({ [classes.highlight_lang]: language.lang === languageKey.en })}
                >
                    EN
                </IconButton>
            </Grid>
            <Grid container item xs alignContent="center" style={{ padding: '0px 2px' }}>
                |
            </Grid>
            <Grid container item xs alignContent="center">
                <IconButton
                    size="small"
                    onClick={language.onClickTH}
                    className={clsx({ [classes.highlight_lang]: language.lang === languageKey.th })}
                >
                    TH
                </IconButton>
            </Grid>
        </Grid>
    )
}

export default Language

const useStyles = makeStyles((theme) => ({
    highlight_lang: {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
    },
}))
